/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  Fragment,
  useContext,
  useReducer,
  useState,
  useEffect,
  useRef,
} from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import { getError } from "../LoadingError/Utils";
import { Store } from "../Store";
import PostProfile from "../Components/PostProfile";
import { useNavigate, Link, useParams } from "react-router-dom";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Modal from "@mui/material/Modal";
import LoadingBox from "../LoadingError/LoadingBox";
import MessageBox from "../LoadingError/MessageBox";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { daDK } from "@mui/x-date-pickers";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { QRCodeSVG } from "qrcode.react";
import MoreVertSharpIcon from "@mui/icons-material/MoreVertSharp";
import NotFoundScreen from "./NotFoundScreen";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FollowersFollowing from "./FollowersFollowingScreen";
import { MdLocationOn, MdAccessTime } from "react-icons/md";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "0.1px solid gainsboro",
  borderRadius: "1rem",
  boxShadow: "1px 2px 1px gainsboro",
  p: 4,
};

const categories = [
  {
    name: "Valentine Specials",
    description: "Exclusive treats for your loved ones.",
    products: [
      {
        name: "Valentine Specials 2025",
        description:
          "2 Tier Black and Pearl Box - Top Tier: Curated Flower Bouquet by Mo Blomma - Bottom Tier: 9pcs Ginchoux Boozy Chocolate Sweets",
        price: "Rp 1.080.000",
        imageUrl: "../images/choux/valentine-spec.jpg",
      },
    ],
  },
  {
    name: "Choux & Baked Goods",
    description: "Delicious choux pastries and baked delights.",
    products: [
      {
        name: "Box of 9",
        description: "A selection of 9 assorted choux pastries.",
        price: "Rp 200.000",
        imageUrl: "../images/choux/choux-box-9.jpg",
      },
      {
        name: "Board",
        description: "An assortment of baked goods presented on a board.",
        price: "Rp 375.000",
        imageUrl: "../images/choux/choux-board.jpg",
      },
      {
        name: "Box of 14",
        description: "A selection of 14 assorted choux pastries.",
        price: "Rp 335.000",
        imageUrl: "../images/choux/choux-box-14.jpg",
      },
    ],
  },
  {
    name: "Cake",
    description: "Indulgent cakes for every occasion.",
    products: [
      {
        name: "Brandy Chocolate",
        description: "Rich chocolate cake infused with brandy.",
        price: "Rp 600.000",
        imageUrl: "https://example.com/brandy-chocolate.jpg",
      },
      {
        name: "Mochi Kiri Cheese Fromage",
        description: "Cheese cake with a mochi twist.",
        price: "Rp 500.000",
        imageUrl: "https://example.com/mochi-kiri-cheese-fromage.jpg",
      },
      {
        name: "Black Forest",
        description: "Classic Black Forest cake with cherries and cream.",
        price: "Rp 550.000",
        imageUrl: "https://example.com/black-forest.jpg",
      },
      {
        name: "Mocha Baileys",
        description: "Mocha flavored cake infused with Baileys.",
        price: "Rp 400.000",
        imageUrl: "https://example.com/mocha-baileys.jpg",
      },
    ],
  },
  // Add other categories and products as needed
];

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, userPostsLoading: true };
    case "FETCHED":
      return { ...state, userPosts: action.payload, userPostsLoading: false };
    case "FETCHED_MORE":
      return {
        ...state,
        userPosts: [...state.userPosts, ...action.payload],
        userPostsLoading: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        userPostsLoading: false,
        userPostsError: action.payload,
      };
    default:
      return state;
  }
};

const reducer2 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loading: true };
    case "FETCHED":
      return { ...state, dataUser: action.payload, loading: false };
    case "FETCH_FAILED":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const reducer3 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, requestIdLoading: true };
    case "FETCHED":
      return { ...state, requestId: action.payload, requestIdLoading: false };
    case "FETCHED_MORE":
      return {
        ...state,
        requestId: [...state.requestId, ...action.payload],
        requestIdLoading: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        requestIdLoading: false,
        requestIdError: action.payload,
      };
    default:
      return state;
  }
};

const reducer4 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingChooseProfile: true };
    case "FETCHED":
      return {
        ...state,
        chooseProfile: action.payload,
        loadingChooseProfile: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingChooseProfile: false,
        errorChooseProfile: action.payload,
      };
    default:
      return state;
  }
};

const reducer5 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingProStatus: true };
    case "FETCHED":
      return {
        ...state,
        proStatus: action.payload,
        loadingProStatus: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingProStatus: false,
        errorProStatus: action.payload,
      };
    default:
      return state;
  }
};

const reducer6 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingAllContactList: true };
    case "FETCHED":
      return {
        ...state,
        dataAllContactList: action.payload,
        loadingAllContactList: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingAllContactList: false,
        errorAllContactList: action.payload,
      };
    default:
      return state;
  }
};

function ProfileScreen() {
  const { state } = useContext(Store);
  const { userInfo } = state;
  let { username } = useParams();

  const [showPostModal, setShowPostModal] = useState(false);
  const [postModalKey, setPostModalKey] = useState("");
  const [postModalData, setPostModalData] = useState("");
  const [showModalUnfollow, setShowModalUnfollow] = useState(false);
  const [page, setPage] = useState(1);
  const divRef = useRef(null);
  const [isFollowed, setIsFollowed] = useState(false);
  const [buttonFollow, setButtonFollow] = useState("Follow");
  const [isLoading, setIsLoading] = useState(false);
  const [showShareProfile, setShowShareProfile] = useState(false);
  const [, setShowShareProfileModal] = useState(false);
  const [socialMediaOptions, setSocialMediaOptions] = useState(true);
  const [, setShowModalContact] = useState(false);
  const [activeTab, setActiveTab] = useState("posts");

  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("");

  const handleOpen = (tab) => {
    setTab(tab);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  const theme = useTheme();
  const isLmm = useMediaQuery(theme.breakpoints.up("lmm"));
  const isLm = useMediaQuery(theme.breakpoints.up("lm"));
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));

  const [{ userPosts }, dispatch] = useReducer(reducer, {
    userPosts: [],
    userPostsLoading: true,
    userPostsError: "",
  });

  const [{ loading, error, dataUser }, dispatch2] = useReducer(reducer2, {
    dataUser: [],
    loading: true,
    error: "",
  });

  const [{ requestId }, dispatch3] = useReducer(reducer3, {
    requestId: [],
    requestIdLoading: true,
    requestIdError: "",
  });

  const [
    { chooseProfile, loadingChooseProfile, errorChooseProfile },
    dispatch4,
  ] = useReducer(reducer4, {
    chooseProfile: [],
    loadingChooseProfile: true,
    errorChooseProfile: "",
  });

  const [{ proStatus }, dispatch5] = useReducer(reducer5, {
    proStatus: [],
    loadingProStatus: true,
    errorProStatus: "",
  });

  const [{ dataAllContactList }, dispatch6] = useReducer(reducer6, {
    dataAllContactList: [],
    loadingAllContactList: true,
    errorAllContactList: "",
  });

  // show other user userPost
  useEffect(async () => {
    if (userInfo === null || dataUser === null) {
      navigate("/");
      return;
    }
    if (chooseProfile.length !== 0) {
      dispatch({
        type: "FETCHING",
      });
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/showUserPost?row=10&page=0&userId=${chooseProfile.user_id}`,
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );
        dispatch({
          type: "FETCHED",
          payload: data.data,
        });
      } catch (error) {
        dispatch({
          type: "FETCH_FAILED",
          payload: error.message,
        });
        toast.error(getError(error));
      }
    }
  }, [userInfo, chooseProfile]);

  // get data user
  useEffect(async () => {
    if (userInfo === null) {
      navigate("/");
      return;
    }

    dispatch2({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/me`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      dispatch2({
        type: "FETCHED",
        payload: data.data,
      });
    } catch (error) {
      dispatch2({
        type: "FETCH_FAILED",
        payload: error.message,
      });
      toast.error(getError(error));
    }
  }, [userInfo]);

  useEffect(async () => {
    if (
      userInfo === null ||
      chooseProfile === null ||
      chooseProfile.user_id === undefined
    ) {
      return;
    }

    try {
      await axios
        .get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/checkFollowed?targetUserId=${chooseProfile.user_id}`,
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        )
        .then((getResponse) => {
          if (getResponse.data.data.followed === true) {
            setButtonFollow("Following");
            setIsFollowed(true);
          }
        });
    } catch (error) {
      toast.error(getError(error));
    }
  }, [userInfo, dataUser, chooseProfile]);

  function Setname() {
    return (
      <p
        style={{
          maxWidth: "50vw",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
          fontSize: "1.5em",
        }}
      >
        {username === dataUser.username ? dataUser.name : chooseProfile.name}
      </p>
    );
  }

  function SetUsername() {
    if (username === dataUser.username) {
      if (dataUser.username === null) {
        return (
          <p
            style={{
              maxWidth: "50vw",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              fontSize: "0.75em",
              color: "#B6B0B0",
            }}
          >
            No UserName
          </p>
        );
      } else {
        return (
          <p
            style={{
              maxWidth: "50vw",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              fontSize: "0.75em",
              color: "#B6B0B0",
            }}
          >
            @{dataUser.username}
          </p>
        );
      }
    } else {
      if (chooseProfile.username === null) {
        return (
          <p
            style={{
              maxWidth: "50vw",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              fontSize: "0.75em",
              color: "#B6B0B0",
            }}
          >
            No UserName
          </p>
        );
      } else {
        return (
          <p
            style={{
              maxWidth: "50vw",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              fontSize: "0.75em",
              color: "#B6B0B0",
            }}
          >
            @{chooseProfile.username}
          </p>
        );
      }
    }
  }

  function SetProfilePicture() {
    if (username === dataUser.username) {
      const isNull = dataUser.picture;
      if (isNull === "null" || isNull === null) {
        return <DefaultPP />;
      } else {
        return <ProfilePicture />;
      }
    } else {
      const isNull = chooseProfile.picture;
      if (isNull === "null" || isNull === null) {
        return <DefaultPP />;
      } else {
        return <ProfilePicture />;
      }
    }
  }

  function DefaultPP() {
    return (
      <img
        className="mb-[-3rem] mt-[-1.7rem] relative top-[-60px] w-[6em] h-[6em] lg:w-[8em] lg:h-[8em]"
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        style={{ borderRadius: "50%" }}
      />
    );
  }

  function ProfilePicture() {
    return (
      <img
        className="mb-[-3rem] mt-[-1.7rem] relative top-[-60px] w-[6em] h-[6em] lg:w-[8em] lg:h-[8em]"
        src={
          username === dataUser.username
            ? dataUser.picture
            : chooseProfile.picture
        }
        alt="profilepicture"
        style={{ borderRadius: "50%" }}
      />
    );
  }

  const handleOpenPostModal = (userPost) => {
    setShowPostModal(true);
    setPostModalKey(userPost.slug);
    setPostModalData(userPost);
  };

  function handleClosePostModal() {
    setShowPostModal(false);
    setPostModalKey("");
    setPostModalData("");
  }

  const userVerificationClicked = async () => {
    dispatch3({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/verifyUserRequest`,
        {},
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      dispatch3({
        type: "FETCHED",
        payload: data.data.request_id,
      });
      toast.success("User verification requested success!");
    } catch (err) {
      dispatch3({
        type: "FETCH_FAILED",
      });
      toast.error(getError(err));
    }
  };
  useEffect(() => {
    if (requestId.length !== 0) {
      navigate("/verified_user", { state: { requestId } });
    }
  }, [requestId]);

  //fetch user profile info
  useEffect(async () => {
    if (dataUser == null || dataUser.length === 0) {
      return;
    }
    dispatch4({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/chooseProfile?username=${username}`,
        {
          auth: {
            username: `${process.env.REACT_APP_BASIC_AUTH_USERNAME}`,
            password: `${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`,
          },
        }
      );
      dispatch4({
        type: "FETCHED",
        payload: data.data,
      });
    } catch (error) {
      dispatch4({
        type: "FETCH_FAILED",
        payload: error.message,
      });
      // toast.error(<div>Page Not Found<br />Sorry, the page you are looking for does not exist.</div>)
    }
  }, [dataUser, username]);

  //Get Pro Status
  useEffect(async () => {
    dispatch5({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/getProStatus`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      dispatch5({
        type: "FETCHED",
        payload: data.data,
      });
    } catch (error) {
      dispatch5({
        type: "FETCH_FAILED",
        payload: error.message,
      });
      toast.error(getError(error));
    }
  }, [userInfo]);

  const handleScroll = () => {
    const divElement = divRef.current;

    if (divElement) {
      const atBottom =
        divElement.scrollHeight - divElement.scrollTop ===
        divElement.clientHeight;

      if (atBottom) {
        fetchMoreUserPosts();
        setPage(page + 1);
      }
    }
  };

  const fetchMoreUserPosts = async () => {
    if (userInfo === null) {
      navigate("/");
      return;
    }

    dispatch({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/showUserPost?row=10&page=${page}`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      dispatch({
        type: "FETCHED_MORE",
        payload: data.data,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_FAILED",
        payload: error.message,
      });
      toast.error(getError(error));
    }
  };

  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  const wordLimit = 15; // Set your word limit here

  function SetDefaultImage(postObject) {
    const userPost = postObject.postObject;
    const mediaUrl =
      userPost.images && userPost.images.length > 0 ? userPost.images[0] : "";

    const isVideo = mediaUrl.includes("smpost-v-");

    return isVideo ? (
      // Render the video element as a static thumbnail
      <video
        className="w-[300px] h-[300px] object-cover rounded-2xl"
        src={mediaUrl}
        muted
        playsInline
        preload="metadata" // Load only metadata and first frame
        disablePictureInPicture
        style={{ pointerEvents: "none" }} // Disable user interaction
      />
    ) : mediaUrl ? (
      // Render an image for non-video media
      <img
        src={mediaUrl}
        alt="Media thumbnail"
        loading="lazy"
        style={{
          width: "300px",
          height: "300px",
          objectFit: "contain",
          borderRadius: "0.5rem",
        }}
      />
    ) : (
      <div
        style={{
          width: "300px",
          height: "300px",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <p
          className="m-12 text-lg font-semibold"
          style={{ fontStyle: "italic", quotes: '"“" "”"' }}
        >
          “{truncateText(userPost.description, wordLimit)}”
        </p>
      </div>
    );
  }

  const typeNames = {
    1: "Product",
    2: "Service",
    3: "Event",
    4: "Job",
    5: "Insight",
    6: "Education",
  };

  const getTypeName = (postType, sdType) => {
    // if (postType === 5 && sdType.value === 1) {
    //   return "Review"; // Adjust as needed if sdType.value should dynamically change the type
    // } else if (postType === 5 && sdType.value === 2) {
    //   return "Question"; // Adjust as needed for sdType.value === 2
    // } else {
    return typeNames[postType] || "Unknown Type";
    // }
  };

  const typeColors = {
    Product: "bg-green-600",
    Service: "bg-blue-600",
    Event: "bg-orange-600",
    Job: "bg-purple-600",

    Insight: "bg-blue-500",
  };

  const defaultColor = "bg-gray-600"; // Default color for unknown types

  const getTypeColor = (postType, sdType) => {
    // if (postType === 5) {
    //   if (sdType.value === 1) {
    //     return typeColors["Review"] || defaultColor;
    //   } else if (sdType.value === 2) {
    //     return typeColors["Question"] || defaultColor;
    //   }
    // }

    // Default to typeColors based on postType if not Review or Question
    return typeColors[typeNames[postType]] || defaultColor;
  };

  const CategoryCard = ({ category }) => (
    <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden mb-8">
      <div className="p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          {category.name}
        </h2>
        <p className="text-gray-600 mb-6">{category.description}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {category.products.map((product) => (
            <div key={product.name} className="flex items-center space-x-4">
              <img
                className="w-20 h-20 object-cover rounded"
                src={product.imageUrl}
                alt={product.name}
              />
              <div>
                <h3 className="text-lg font-semibold text-gray-700">
                  {product.name}
                </h3>
                <p className="text-gray-500">{product.price}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const followHandler = async () => {
    setIsLoading(true);
    try {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/follow`,
          {
            targetUserId: chooseProfile.user_id,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        )
        .then((getResponse) => {
          toast.success("User followed!");
          setIsLoading(false);
        });
      setButtonFollow("Following");
      setIsFollowed(true);
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/sendNotif`,
        {
          postId: null,
          targetUserId: chooseProfile.user_id,
          notifNumber: 3,
          comment: null,
          detailId: null,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
    } catch (error) {
      toast.error(getError(error));
    }
  };

  const unfollowHandler = (e) => {
    setIsLoading(true);
    try {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/unfollow`,
          {
            targetUserId: chooseProfile.user_id,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        )
        .then((getResponse) => {
          toast.success("User unfollowed!");
          setIsLoading(false);
        });
      setShowModalUnfollow(false);
      setButtonFollow("Follow");
      setIsFollowed(false);
    } catch (error) {
      toast.error(getError(error));
    }
  };

  function handleButtonFollow(e) {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      if (isFollowed === false) {
        setIsLoading(false);
        followHandler();
      } else {
        setIsLoading(false);
        setShowModalUnfollow(true);
      }
    }, 1000);
  }
  function handleCloseModalUnfollow() {
    setShowModalUnfollow(false);
  }

  function handleUnfollowButtonModal() {
    unfollowHandler();
  }

  function handleCancelButtonModalUnfollow() {
    setShowModalUnfollow(false);
  }

  const handleCopyLink = () => {
    const postLink = `https://siaphub.com/${username}`;

    // Copy the link to the clipboard
    navigator.clipboard
      .writeText(postLink)
      .then(() => {
        toast.success("Link copied to clipboard", postLink);
        // You can provide feedback to the user that the link has been copied if needed
      })
      .catch((err) => {
        toast.error("Unable to copy link to clipboard", err);
        // Handle the error, e.g., show an error message to the user
      });
  };

  // Upper part profile screen ⬇️⬇️

  function handleCloseShareProfileModalChat() {
    setShowShareProfileModal(false);
  }

  const handleCancelButtonModalShareProfile = () => {
    setShowShareProfile(false);
    setShowShareProfileModal(false);
  };

  // message user function ⬇️

  const messageTargetedUser = (targetUser) => {
    navigate("/all_chat", { state: { targetUser } });
  };

  useEffect(async () => {
    dispatch6({
      type: "FETCHING",
    });

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/getAllContactList`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );

      const socialMediaOptions = data.data.map((item, index) => ({
        value: item.id.toString(),
        label: item.name,
        image: item.image,
        url: item.url,
      }));

      dispatch6({
        type: "FETCHED",
        payload: data.data,
      });

      setSocialMediaOptions(socialMediaOptions);
    } catch (error) {
      dispatch6({
        type: "FETCH_FAILED",
        payload: error.message,
      });
    }
  }, []);

  const openContact = (contact_id) => {
    let url;
    if (dataAllContactList) {
      if (contact_id) {
        let contact = chooseProfile.contact.find(
          (item) => item.listcontact_id === contact_id
        );
        if (contact.link) {
          if (
            contact.link.startsWith("http://") ||
            contact.link.startsWith("https://")
          ) {
            url = contact.link.replace(/\s/g, "");
          } else if (
            contact.link.startsWith("08") ||
            contact.link.startsWith("+")
          ) {
            url = "tel:" + contact.link;
          } else {
            url = "https://" + contact.link.replace(/\s/g, "");
          }
          window.open(url);
        } else {
          toast.error("URL not found!");
        }
      } else {
        toast.error("Contact not found!");
      }
    } else {
      toast.error("dataAllContactList not found!");
    }
  };

  return (
    <>
      {errorChooseProfile && chooseProfile.length === 0 ? (
        <MessageBox severity="error">
          <NotFoundScreen />
        </MessageBox>
      ) : (
        <>
          {loading || loadingChooseProfile ? (
            <div className="flex justify-center pt-6 mt-32">
              <LoadingBox />
            </div>
          ) : error ? (
            <MessageBox severity="error">{error}</MessageBox>
          ) : (
            <div className="h-fit">
              <div
                className="flex w-full items-center justify-start"
                style={{ flexDirection: "column" }}
              >
                <Helmet>
                  <title>{username} | SiapHub</title>
                </Helmet>
                <div
                  className="flex flex-none w-full"
                  style={{
                    justifyContent: "center",
                    backgroundImage: "url(../images/back_profile.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="card-profile-top w-[50rem]"
                    style={{
                      backgroundColor: "white",
                      marginTop: "1.5rem",
                      height: "auto",
                    }}
                  >
                    <div>
                      <div>
                        <div>
                          {/* Personal Profile Section */}
                          {username === dataUser.username ? (
                            <div className="flex justify-end">
                              <div className="flex w-56 justify-end lg:justify-between">
                                <div className="hidden lg:flex">
                                  <Tooltip title="Share Profile">
                                    <button
                                      className="whitespace-nowrap inline-flex justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-[#F5F5F5]"
                                      onClick={() => setShowShareProfile(true)}
                                    >
                                      Share Profile
                                    </button>
                                  </Tooltip>
                                  <Modal
                                    open={showShareProfile}
                                    onClose={handleCloseShareProfileModalChat}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                  >
                                    <Box className="modal-notification-style">
                                      <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        component="h2"
                                        style={{
                                          marginBottom: "10%",
                                          marginTop: "5%",
                                          textAlign: "center",
                                        }}
                                      >
                                        Share Profile
                                        <div className="flex justify-center">
                                          <QRCodeSVG
                                            value={`https://siaphub.com/${username}`}
                                            size={200}
                                            bgColor={"#ffffff"}
                                            fgColor={"#000000"}
                                            level={"H"}
                                            includeMargin={false}
                                            imageSettings={{
                                              src:
                                                dataUser.picture !== null
                                                  ? dataUser.picture
                                                  : "../images/pp/defaultpp.png",
                                              height: 50,
                                              width: 50,
                                              excavate: true,
                                            }}
                                          />
                                        </div>
                                      </Typography>

                                      {/* <div className="m-2 text-center text-sm">{`https://siaphub.com/${username}`}</div> */}
                                      <div className="flex justify-center">
                                        <button
                                          type="button"
                                          className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                                          onClick={() => {
                                            handleCopyLink();
                                            handleCancelButtonModalShareProfile();
                                          }}
                                        >
                                          Copy Link
                                        </button>
                                        <button
                                          type="button"
                                          className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                                          onClick={
                                            handleCancelButtonModalShareProfile
                                          }
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </Box>
                                  </Modal>
                                </div>
                                {/* Desktop */}
                                <Menu
                                  as="div"
                                  className="relative inline-block text-left"
                                >
                                  <Tooltip title="Options">
                                    <Menu.Button className="hidden lg:flex inline-flex w-full justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-[#F5F5F5]">
                                      Options
                                      <ChevronDownIcon
                                        className="-mr-1 h-5 w-5 text-gray-400"
                                        aria-hidden="true"
                                      />
                                    </Menu.Button>
                                  </Tooltip>
                                  <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                  >
                                    <Menu.Items className="absolute right-0 z-10 w-[17rem] origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                      <div className="py-2">
                                        <Menu.Item
                                          className={({ active }) =>
                                            `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                              active ? "bg-[#F5F5F5]" : ""
                                            }`
                                          }
                                        >
                                          <Link
                                            to="/update_password"
                                            className="cursor-pointer flex"
                                          >
                                            <div className="flex items-center">
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="rounded-full lg:scale-125"
                                              >
                                                <circle
                                                  cx="15"
                                                  cy="15"
                                                  r="15"
                                                  fill="none"
                                                />
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M9.47528 10.3543C9.47528 9.17708 9.94402 8.04805 10.7784 7.21562C11.6128 6.38318 12.7444 5.91553 13.9244 5.91553C15.1043 5.91553 16.236 6.38318 17.0703 7.21562C17.9047 8.04805 18.3735 9.17708 18.3735 10.3543C18.3735 11.5316 17.9047 12.6606 17.0703 13.493C16.236 14.3255 15.1043 14.7931 13.9244 14.7931C12.7444 14.7931 11.6128 14.3255 10.7784 13.493C9.94402 12.6606 9.47528 11.5316 9.47528 10.3543ZM13.9244 7.69104C13.5738 7.69104 13.2267 7.75993 12.9028 7.89377C12.5789 8.02762 12.2847 8.22379 12.0368 8.4711C11.7889 8.71841 11.5923 9.012 11.4581 9.33513C11.324 9.65825 11.2549 10.0046 11.2549 10.3543C11.2549 10.7041 11.324 11.0504 11.4581 11.3735C11.5923 11.6966 11.7889 11.9902 12.0368 12.2375C12.2847 12.4848 12.5789 12.681 12.9028 12.8149C13.2267 12.9487 13.5738 13.0176 13.9244 13.0176C14.6324 13.0176 15.3113 12.737 15.812 12.2375C16.3126 11.7381 16.5938 11.0607 16.5938 10.3543C16.5938 9.64797 16.3126 8.97056 15.812 8.4711C15.3113 7.97164 14.6324 7.69104 13.9244 7.69104ZM8.06314 19.7654C7.77573 20.1294 7.69565 20.4046 7.69565 20.5635C7.69565 20.6683 7.72679 20.7695 7.87806 20.9044C8.05336 21.0607 8.36746 21.2329 8.86576 21.3865C9.86235 21.6937 11.3181 21.849 13.0532 21.8863C13.1701 21.8887 13.2853 21.9141 13.3923 21.961C13.4994 22.0079 13.5961 22.0753 13.677 22.1595C13.7579 22.2437 13.8213 22.3429 13.8638 22.4515C13.9062 22.5602 13.9268 22.6761 13.9244 22.7927C13.9219 22.9093 13.8965 23.0242 13.8495 23.131C13.8025 23.2378 13.7349 23.3343 13.6505 23.415C13.5662 23.4957 13.4667 23.559 13.3578 23.6014C13.2489 23.6437 13.1327 23.6643 13.0159 23.6618C11.2389 23.6236 9.58117 23.4656 8.34077 23.083C7.72145 22.8912 7.13595 22.624 6.69283 22.229C6.22478 21.8117 5.91602 21.2507 5.91602 20.5635C5.91602 19.8649 6.23457 19.2115 6.66702 18.6646C7.10659 18.1098 7.71434 17.5993 8.42708 17.1643C9.85346 16.297 11.7933 15.6809 13.9244 15.6809C14.3221 15.6809 14.7136 15.7022 15.0954 15.743C15.3301 15.7678 15.5453 15.8847 15.6936 16.0678C15.842 16.251 15.9113 16.4854 15.8864 16.7195C15.8615 16.9537 15.7444 17.1684 15.5608 17.3164C15.3773 17.4644 15.1423 17.5336 14.9076 17.5088C14.5873 17.4741 14.258 17.4564 13.9244 17.4564C12.1243 17.4564 10.5048 17.9802 9.35427 18.6806C8.77856 19.0304 8.34344 19.4103 8.06314 19.7654ZM23.0121 16.5988C22.8055 16.3927 22.5602 16.2291 22.2903 16.1176C22.0204 16.006 21.7311 15.9486 21.4389 15.9486C21.1467 15.9486 20.8574 16.006 20.5874 16.1176C20.3175 16.2291 20.0723 16.3927 19.8657 16.5988L16.8243 19.6323C16.6201 19.8362 16.4877 20.1006 16.447 20.386L16.1534 22.4349C16.1337 22.5716 16.1462 22.7109 16.19 22.8419C16.2337 22.9729 16.3074 23.0919 16.4052 23.1895C16.5031 23.2871 16.6223 23.3606 16.7536 23.4042C16.8849 23.4479 17.0246 23.4604 17.1615 23.4408L19.2152 23.1478C19.5012 23.1072 19.7663 22.9751 19.9707 22.7714L23.0112 19.737C23.4282 19.3208 23.6625 18.7564 23.6625 18.1679C23.6625 17.5794 23.4291 17.015 23.0121 16.5988ZM21.1239 17.8541C21.2078 17.7732 21.3202 17.7285 21.4368 17.7295C21.5535 17.7305 21.6651 17.7772 21.7476 17.8595C21.83 17.9418 21.8768 18.0531 21.8779 18.1695C21.8789 18.2859 21.834 18.398 21.753 18.4817L18.8166 21.4113L18.0825 21.5161L18.1875 20.7837L21.1239 17.8541Z"
                                                  fill="black"
                                                />
                                              </svg>
                                              <div className="flex items-center">
                                                Change Password
                                              </div>
                                            </div>
                                          </Link>
                                        </Menu.Item>
                                        {/* <Menu.Item className="lg:hidden">
                                          <div
                                            className="flex items-center cursor-pointer"
                                            onClick={() =>
                                              setShowShareProfile(true)
                                            }
                                          >
                                            <svg
                                              width="30"
                                              height="30"
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="rounded-full lg:scale-125"
                                            >
                                              <circle
                                                cx="15"
                                                cy="15"
                                                r="15"
                                                fill="white"
                                              />
                                              <path
                                                d="M19.5986 6C21.4772 6 23 7.5675 23 9.50112C23 11.4347 21.4772 13.0022 19.5986 13.0022C18.5981 13.0022 17.6986 12.5576 17.0763 11.8499L12.6483 14.4539C12.7487 14.7842 12.8027 15.1356 12.8027 15.5C12.8027 15.8644 12.7487 16.2157 12.6483 16.5461L17.0754 19.1511C17.6977 18.4427 18.5976 17.9977 19.5986 17.9977C21.4772 17.9977 23 19.5652 23 21.4989C23 23.4325 21.4772 25 19.5986 25C17.7201 25 16.1972 23.4325 16.1972 21.4989C16.1972 21.1345 16.2513 20.7831 16.3516 20.4528L11.9246 17.8478C11.3022 18.5561 10.4023 19.0011 9.40137 19.0011C7.52285 19.0011 6 17.4336 6 15.5C6 13.5663 7.52285 11.9989 9.40137 11.9989C10.4018 11.9989 11.3014 12.4435 11.9237 13.1512L16.3516 10.5472C16.2513 10.2169 16.1972 9.8655 16.1972 9.50112C16.1972 7.5675 17.7201 6 19.5986 6ZM19.5986 19.4974C18.5248 19.4974 17.6542 20.3936 17.6542 21.4989C17.6542 22.6042 18.5248 23.5003 19.5986 23.5003C20.6724 23.5003 21.543 22.6042 21.543 21.4989C21.543 20.3936 20.6724 19.4974 19.5986 19.4974ZM9.40137 13.4986C8.32752 13.4986 7.45699 14.3947 7.45699 15.5C7.45699 16.6054 8.32752 17.5014 9.40137 17.5014C10.4752 17.5014 11.3457 16.6054 11.3457 15.5C11.3457 14.3947 10.4752 13.4986 9.40137 13.4986ZM19.5986 7.49972C18.5248 7.49972 17.6542 8.39577 17.6542 9.50112C17.6542 10.6064 18.5248 11.5025 19.5986 11.5025C20.6724 11.5025 21.543 10.6064 21.543 9.50112C21.543 8.39577 20.6724 7.49972 19.5986 7.49972Z"
                                                fill="#212121"
                                              />
                                            </svg>

                                            <div>Share Profile</div>
                                          </div>
                                        </Menu.Item> */}
                                        <Menu.Item
                                          className={({ active }) =>
                                            `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                              active ? "bg-[#F5F5F5]" : ""
                                            }`
                                          }
                                        >
                                          <Link
                                            to="/update_profile"
                                            className="cursor-pointer flex"
                                          >
                                            <svg
                                              width="30"
                                              height="30"
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="rounded-full lg:scale-125"
                                            >
                                              <circle
                                                cx="15"
                                                cy="15"
                                                r="15"
                                                fill="none"
                                              />
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M9.47528 10.3543C9.47528 9.17708 9.94402 8.04805 10.7784 7.21562C11.6128 6.38318 12.7444 5.91553 13.9244 5.91553C15.1043 5.91553 16.236 6.38318 17.0703 7.21562C17.9047 8.04805 18.3735 9.17708 18.3735 10.3543C18.3735 11.5316 17.9047 12.6606 17.0703 13.493C16.236 14.3255 15.1043 14.7931 13.9244 14.7931C12.7444 14.7931 11.6128 14.3255 10.7784 13.493C9.94402 12.6606 9.47528 11.5316 9.47528 10.3543ZM13.9244 7.69104C13.5738 7.69104 13.2267 7.75993 12.9028 7.89377C12.5789 8.02762 12.2847 8.22379 12.0368 8.4711C11.7889 8.71841 11.5923 9.012 11.4581 9.33513C11.324 9.65825 11.2549 10.0046 11.2549 10.3543C11.2549 10.7041 11.324 11.0504 11.4581 11.3735C11.5923 11.6966 11.7889 11.9902 12.0368 12.2375C12.2847 12.4848 12.5789 12.681 12.9028 12.8149C13.2267 12.9487 13.5738 13.0176 13.9244 13.0176C14.6324 13.0176 15.3113 12.737 15.812 12.2375C16.3126 11.7381 16.5938 11.0607 16.5938 10.3543C16.5938 9.64797 16.3126 8.97056 15.812 8.4711C15.3113 7.97164 14.6324 7.69104 13.9244 7.69104ZM8.06314 19.7654C7.77573 20.1294 7.69565 20.4046 7.69565 20.5635C7.69565 20.6683 7.72679 20.7695 7.87806 20.9044C8.05336 21.0607 8.36746 21.2329 8.86576 21.3865C9.86235 21.6937 11.3181 21.849 13.0532 21.8863C13.1701 21.8887 13.2853 21.9141 13.3923 21.961C13.4994 22.0079 13.5961 22.0753 13.677 22.1595C13.7579 22.2437 13.8213 22.3429 13.8638 22.4515C13.9062 22.5602 13.9268 22.6761 13.9244 22.7927C13.9219 22.9093 13.8965 23.0242 13.8495 23.131C13.8025 23.2378 13.7349 23.3343 13.6505 23.415C13.5662 23.4957 13.4667 23.559 13.3578 23.6014C13.2489 23.6437 13.1327 23.6643 13.0159 23.6618C11.2389 23.6236 9.58117 23.4656 8.34077 23.083C7.72145 22.8912 7.13595 22.624 6.69283 22.229C6.22478 21.8117 5.91602 21.2507 5.91602 20.5635C5.91602 19.8649 6.23457 19.2115 6.66702 18.6646C7.10659 18.1098 7.71434 17.5993 8.42708 17.1643C9.85346 16.297 11.7933 15.6809 13.9244 15.6809C14.3221 15.6809 14.7136 15.7022 15.0954 15.743C15.3301 15.7678 15.5453 15.8847 15.6936 16.0678C15.842 16.251 15.9113 16.4854 15.8864 16.7195C15.8615 16.9537 15.7444 17.1684 15.5608 17.3164C15.3773 17.4644 15.1423 17.5336 14.9076 17.5088C14.5873 17.4741 14.258 17.4564 13.9244 17.4564C12.1243 17.4564 10.5048 17.9802 9.35427 18.6806C8.77856 19.0304 8.34344 19.4103 8.06314 19.7654ZM23.0121 16.5988C22.8055 16.3927 22.5602 16.2291 22.2903 16.1176C22.0204 16.006 21.7311 15.9486 21.4389 15.9486C21.1467 15.9486 20.8574 16.006 20.5874 16.1176C20.3175 16.2291 20.0723 16.3927 19.8657 16.5988L16.8243 19.6323C16.6201 19.8362 16.4877 20.1006 16.447 20.386L16.1534 22.4349C16.1337 22.5716 16.1462 22.7109 16.19 22.8419C16.2337 22.9729 16.3074 23.0919 16.4052 23.1895C16.5031 23.2871 16.6223 23.3606 16.7536 23.4042C16.8849 23.4479 17.0246 23.4604 17.1615 23.4408L19.2152 23.1478C19.5012 23.1072 19.7663 22.9751 19.9707 22.7714L23.0112 19.737C23.4282 19.3208 23.6625 18.7564 23.6625 18.1679C23.6625 17.5794 23.4291 17.015 23.0121 16.5988ZM21.1239 17.8541C21.2078 17.7732 21.3202 17.7285 21.4368 17.7295C21.5535 17.7305 21.6651 17.7772 21.7476 17.8595C21.83 17.9418 21.8768 18.0531 21.8779 18.1695C21.8789 18.2859 21.834 18.398 21.753 18.4817L18.8166 21.4113L18.0825 21.5161L18.1875 20.7837L21.1239 17.8541Z"
                                                fill="black"
                                              />
                                            </svg>
                                            <div className="flex items-center">
                                              Update Profile
                                            </div>
                                          </Link>
                                        </Menu.Item>
                                        {dataUser.follower_count >= 100 ? (
                                          <Menu.Item
                                            className={({ active }) =>
                                              `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                                active ? "bg-[#F5F5F5]" : ""
                                              }`
                                            }
                                          >
                                            <div
                                              onClick={() => {
                                                if (
                                                  dataUser.follower_count >= 100
                                                ) {
                                                  userVerificationClicked();
                                                }
                                              }}
                                              className="cursor-pointer flex"
                                            >
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill-opacity={
                                                  dataUser.follower_count < 100
                                                    ? 0.3
                                                    : 1
                                                }
                                                className={`rounded-full lg:scale-125  ${
                                                  dataUser.follower_count < 100
                                                    ? "hidden"
                                                    : ""
                                                }`}
                                              >
                                                <circle
                                                  cx="15"
                                                  cy="15"
                                                  r="15"
                                                  fill="none"
                                                />
                                                <path
                                                  d="M19 15.5C19 14.8974 18.825 14.3287 18.5182 13.8335C17.8409 12.7418 16.5205 12 15 12C12.7909 12 11 13.567 11 15.5C11 16.8304 11.8477 17.9858 13.0955 18.5784C13.6614 18.8469 14.3091 19 15 19C17.2091 19 19 17.433 19 15.5ZM12.4545 15.5C12.4545 14.9054 12.7205 14.3466 13.2 13.925C13.6818 13.5034 14.3205 13.2727 15 13.2727C15.6795 13.2727 16.3182 13.5034 16.8 13.925C17.0368 14.1316 17.2245 14.3771 17.3524 14.6474C17.4804 14.9177 17.546 15.2074 17.5455 15.5C17.5455 16.0946 17.2795 16.6534 16.8 17.075C16.5639 17.2822 16.2833 17.4465 15.9744 17.5584C15.6655 17.6703 15.3344 17.7277 15 17.7273C14.3205 17.7273 13.6818 17.4946 13.2 17.075C12.9632 16.8684 12.7755 16.6229 12.6476 16.3526C12.5196 16.0823 12.454 15.7926 12.4545 15.5Z"
                                                  fill="black"
                                                />
                                                <path
                                                  d="M16.7443 24.8388C16.8801 24.8142 17.0052 24.7489 17.103 24.6516C17.2008 24.5542 17.2666 24.4295 17.2918 24.2938L17.6249 22.4913C18.3928 22.2036 19.1078 21.7909 19.7407 21.2698L21.466 21.8826C21.5959 21.9286 21.7368 21.9339 21.8698 21.8979C22.0029 21.8619 22.1218 21.7863 22.2108 21.6812L22.249 21.6366C22.9875 20.7651 23.5563 19.7811 23.9404 18.7123L23.9595 18.6571C23.9955 18.5596 24.0061 18.4578 23.9955 18.3581C23.9764 18.1906 23.8958 18.0315 23.7621 17.9149L22.3764 16.7294L22.3721 16.7273C22.4379 16.3244 22.4719 15.913 22.4719 15.5016C22.4719 15.1432 22.4464 14.7827 22.3955 14.4307C22.3891 14.384 22.3806 14.3374 22.3742 14.2907C22.3742 14.2865 22.3721 14.2801 22.3721 14.2759L23.7621 13.0883C23.9085 12.9632 23.9934 12.7829 23.9998 12.5963C24.0019 12.5115 23.9892 12.4245 23.9595 12.3418L23.9404 12.2867C23.5577 11.2179 22.9847 10.2272 22.249 9.3623L22.2108 9.31776C22.1216 9.2129 22.0026 9.13752 21.8697 9.10156C21.7367 9.06559 21.596 9.07073 21.466 9.1163L19.7407 9.72917C19.1041 9.20749 18.3953 8.79608 17.6271 8.50767H17.6249L17.2918 6.70512C17.2897 6.69451 17.2875 6.68179 17.2833 6.67119C17.2526 6.54297 17.1854 6.42641 17.0897 6.33568C16.994 6.24495 16.874 6.18395 16.7443 6.16011L16.687 6.14951C15.5813 5.95016 14.4184 5.95016 13.3128 6.14951L13.2555 6.16011C13.1197 6.1847 12.9946 6.25001 12.8968 6.34736C12.799 6.44471 12.7331 6.56949 12.708 6.70512L12.3727 8.51616C11.6106 8.80463 10.901 9.21581 10.2718 9.73341L8.53381 9.1163C8.40386 9.07037 8.26301 9.06505 8.12996 9.10103C7.99691 9.13702 7.87797 9.21261 7.78895 9.31776L7.75075 9.3623C7.01596 10.2278 6.44305 11.2184 6.05942 12.2867L6.04032 12.3418C5.9961 12.4651 5.9884 12.5984 6.01813 12.726C6.04787 12.8535 6.11378 12.9697 6.20797 13.0607C6.21858 13.0692 6.22707 13.0798 6.23768 13.0883L7.64464 14.2886V14.2907C7.57886 14.6894 7.54703 15.0944 7.54703 15.4995C7.54703 15.9066 7.57886 16.3138 7.64464 16.7104L6.23768 17.9107C6.13284 18.0003 6.0578 18.1198 6.02255 18.2531C5.9873 18.3865 5.9935 18.5274 6.04032 18.6571L6.05942 18.7123C6.44353 19.7811 7.01225 20.7672 7.75075 21.6366L7.78895 21.6812C7.89293 21.8021 8.03087 21.8805 8.18154 21.9081C8.29613 21.9293 8.41709 21.9229 8.53381 21.8826L10.2718 21.2655C10.2739 21.2676 10.2782 21.2698 10.2803 21.2719C10.9106 21.7872 11.613 22.1965 12.3727 22.4828L12.708 24.2938C12.7331 24.4295 12.799 24.5542 12.8968 24.6516C12.9946 24.7489 13.1197 24.8142 13.2555 24.8388L13.3128 24.8494C13.8667 24.9491 14.4333 25 14.9999 25H15.0063C15.5707 25 16.1373 24.9491 16.687 24.8494L16.7443 24.8388ZM15.8997 23.4286C15.3003 23.4965 14.6952 23.4965 14.0959 23.4286L13.716 21.3673L12.9139 21.0598C12.309 20.8308 11.7467 20.5042 11.2437 20.0907L10.5774 19.5414L8.59535 20.2455C8.23459 19.7599 7.93325 19.2361 7.69133 18.6847L9.29353 17.3169L9.15559 16.4686C9.10466 16.1526 9.07707 15.8261 9.07707 15.5037C9.07707 15.1793 9.10253 14.8548 9.15559 14.5388L9.29353 13.6906L7.69133 12.3227C7.93113 11.7692 8.23459 11.2476 8.59535 10.7619L10.5774 11.466L11.2437 10.9167C11.7467 10.5032 12.309 10.1766 12.9139 9.9476L13.7181 9.64434L14.098 7.58307C14.6943 7.51521 15.3034 7.51521 15.9018 7.58307L16.2816 9.6401L17.0902 9.94336C17.6992 10.1724 18.2658 10.499 18.773 10.9146L19.4394 11.4617L21.4087 10.764C21.7694 11.2497 22.0708 11.7735 22.3127 12.3249L20.7275 13.6799L20.8654 14.5261C20.9185 14.8463 20.9461 15.175 20.9461 15.5037C20.9461 15.8324 20.9185 16.1611 20.8654 16.4813L20.7254 17.3317L22.3106 18.6868C22.0703 19.2401 21.7669 19.7638 21.4066 20.2476L19.4372 19.5499L18.7709 20.097C18.2637 20.5127 17.6992 20.8393 17.088 21.0683L16.2795 21.3716L15.8997 23.4286Z"
                                                  fill="black"
                                                />
                                              </svg>
                                              <div
                                                className={`flex items-center  ${
                                                  dataUser.follower_count < 100
                                                    ? "hidden"
                                                    : ""
                                                }`}
                                              >
                                                User Verification Request
                                              </div>
                                            </div>
                                          </Menu.Item>
                                        ) : null}
                                        {proStatus && proStatus.result ? (
                                          <Menu.Item
                                            className={({ active }) =>
                                              `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                                active ? "bg-[#F5F5F5]" : ""
                                              }`
                                            }
                                          >
                                            <Link
                                              to="/edit_professional_account"
                                              className="cursor-pointer flex"
                                            >
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="rounded-full lg:scale-125"
                                              >
                                                <circle
                                                  cx="15"
                                                  cy="15"
                                                  r="15"
                                                  fill="none"
                                                />
                                                <path
                                                  d="M19.905 15.6511C22.0988 16.2397 24 17.2029 24 18.5407V23H6V18.5407C6 17.2029 7.90125 16.2397 10.1063 15.6511L10.8038 16.757L11.0625 17.2029C9.375 17.6132 8.1375 18.2018 8.1375 18.5407V21.3055H12.885L13.875 16.7837L12.8175 15.107C13.515 15.0446 14.2463 15 15 15C15.7538 15 16.485 15.0446 17.1825 15.107L16.125 16.7837L17.115 21.3055H21.8625V18.5407C21.8625 18.2018 20.625 17.6132 18.9375 17.2029L19.1962 16.757L19.905 15.6511Z"
                                                  fill="black"
                                                />
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M10 9.26524C10 8.13403 10.4769 7.04915 11.3258 6.24926C12.1747 5.44937 13.3261 5 14.5266 5C15.7271 5 16.8785 5.44937 17.7274 6.24926C18.5763 7.04915 19.0532 8.13403 19.0532 9.26524C19.0532 10.3965 18.5763 11.4813 17.7274 12.2812C16.8785 13.0811 15.7271 13.5305 14.5266 13.5305C13.3261 13.5305 12.1747 13.0811 11.3258 12.2812C10.4769 11.4813 10 10.3965 10 9.26524ZM14.5266 6.7061C14.1699 6.7061 13.8168 6.77229 13.4873 6.9009C13.1577 7.02951 12.8583 7.21802 12.6061 7.45565C12.3539 7.69329 12.1539 7.97541 12.0174 8.2859C11.8809 8.59639 11.8106 8.92917 11.8106 9.26524C11.8106 9.60132 11.8809 9.9341 12.0174 10.2446C12.1539 10.5551 12.3539 10.8372 12.6061 11.0748C12.8583 11.3125 13.1577 11.501 13.4873 11.6296C13.8168 11.7582 14.1699 11.8244 14.5266 11.8244C15.2469 11.8244 15.9378 11.5548 16.4471 11.0748C16.9564 10.5949 17.2426 9.94397 17.2426 9.26524C17.2426 8.58652 16.9564 7.93559 16.4471 7.45565C15.9378 6.97572 15.2469 6.7061 14.5266 6.7061Z"
                                                  fill="black"
                                                />
                                              </svg>

                                              <div className="flex items-center">
                                                Edit Your Professional Account
                                              </div>
                                            </Link>
                                          </Menu.Item>
                                        ) : (
                                          <Menu.Item
                                            className={({ active }) =>
                                              `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                                active ? "bg-[#F5F5F5]" : ""
                                              }`
                                            }
                                          >
                                            <Link
                                              to="/professional_account"
                                              className="cursor-pointer flex"
                                            >
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="rounded-full lg:scale-125"
                                              >
                                                <circle
                                                  cx="15"
                                                  cy="15"
                                                  r="15"
                                                  fill="none"
                                                />
                                                <path
                                                  d="M19.905 15.6511C22.0988 16.2397 24 17.2029 24 18.5407V23H6V18.5407C6 17.2029 7.90125 16.2397 10.1063 15.6511L10.8038 16.757L11.0625 17.2029C9.375 17.6132 8.1375 18.2018 8.1375 18.5407V21.3055H12.885L13.875 16.7837L12.8175 15.107C13.515 15.0446 14.2463 15 15 15C15.7538 15 16.485 15.0446 17.1825 15.107L16.125 16.7837L17.115 21.3055H21.8625V18.5407C21.8625 18.2018 20.625 17.6132 18.9375 17.2029L19.1962 16.757L19.905 15.6511Z"
                                                  fill="black"
                                                />
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M10 9.26524C10 8.13403 10.4769 7.04915 11.3258 6.24926C12.1747 5.44937 13.3261 5 14.5266 5C15.7271 5 16.8785 5.44937 17.7274 6.24926C18.5763 7.04915 19.0532 8.13403 19.0532 9.26524C19.0532 10.3965 18.5763 11.4813 17.7274 12.2812C16.8785 13.0811 15.7271 13.5305 14.5266 13.5305C13.3261 13.5305 12.1747 13.0811 11.3258 12.2812C10.4769 11.4813 10 10.3965 10 9.26524ZM14.5266 6.7061C14.1699 6.7061 13.8168 6.77229 13.4873 6.9009C13.1577 7.02951 12.8583 7.21802 12.6061 7.45565C12.3539 7.69329 12.1539 7.97541 12.0174 8.2859C11.8809 8.59639 11.8106 8.92917 11.8106 9.26524C11.8106 9.60132 11.8809 9.9341 12.0174 10.2446C12.1539 10.5551 12.3539 10.8372 12.6061 11.0748C12.8583 11.3125 13.1577 11.501 13.4873 11.6296C13.8168 11.7582 14.1699 11.8244 14.5266 11.8244C15.2469 11.8244 15.9378 11.5548 16.4471 11.0748C16.9564 10.5949 17.2426 9.94397 17.2426 9.26524C17.2426 8.58652 16.9564 7.93559 16.4471 7.45565C15.9378 6.97572 15.2469 6.7061 14.5266 6.7061Z"
                                                  fill="black"
                                                />
                                              </svg>

                                              <div className="flex items-center">
                                                Upgrade Professional Account
                                              </div>
                                            </Link>
                                          </Menu.Item>
                                        )}
                                      </div>
                                    </Menu.Items>
                                  </Transition>
                                </Menu>
                                {/* Mobile */}
                                <Menu
                                  as="div"
                                  className="relative inline-block text-left"
                                >
                                  <Tooltip title="Options">
                                    <Menu.Button className="lg:hidden inline-flex w-full justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-[#F5F5F5]">
                                      <MoreVertSharpIcon
                                        style={{ cursor: "pointer" }}
                                      />
                                    </Menu.Button>
                                  </Tooltip>
                                  <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                  >
                                    <Menu.Items className="absolute right-0 z-10 w-[17rem] origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                      <div className="py-2">
                                        <Menu.Item
                                          className={({ active }) =>
                                            `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                              active ? "bg-[#F5F5F5]" : ""
                                            }`
                                          }
                                        >
                                          <Link
                                            to="/update_password"
                                            className="cursor-pointer flex"
                                          >
                                            <div className="flex items-center">
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="rounded-full lg:scale-125"
                                              >
                                                <circle
                                                  cx="15"
                                                  cy="15"
                                                  r="15"
                                                  fill="none"
                                                />
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M9.47528 10.3543C9.47528 9.17708 9.94402 8.04805 10.7784 7.21562C11.6128 6.38318 12.7444 5.91553 13.9244 5.91553C15.1043 5.91553 16.236 6.38318 17.0703 7.21562C17.9047 8.04805 18.3735 9.17708 18.3735 10.3543C18.3735 11.5316 17.9047 12.6606 17.0703 13.493C16.236 14.3255 15.1043 14.7931 13.9244 14.7931C12.7444 14.7931 11.6128 14.3255 10.7784 13.493C9.94402 12.6606 9.47528 11.5316 9.47528 10.3543ZM13.9244 7.69104C13.5738 7.69104 13.2267 7.75993 12.9028 7.89377C12.5789 8.02762 12.2847 8.22379 12.0368 8.4711C11.7889 8.71841 11.5923 9.012 11.4581 9.33513C11.324 9.65825 11.2549 10.0046 11.2549 10.3543C11.2549 10.7041 11.324 11.0504 11.4581 11.3735C11.5923 11.6966 11.7889 11.9902 12.0368 12.2375C12.2847 12.4848 12.5789 12.681 12.9028 12.8149C13.2267 12.9487 13.5738 13.0176 13.9244 13.0176C14.6324 13.0176 15.3113 12.737 15.812 12.2375C16.3126 11.7381 16.5938 11.0607 16.5938 10.3543C16.5938 9.64797 16.3126 8.97056 15.812 8.4711C15.3113 7.97164 14.6324 7.69104 13.9244 7.69104ZM8.06314 19.7654C7.77573 20.1294 7.69565 20.4046 7.69565 20.5635C7.69565 20.6683 7.72679 20.7695 7.87806 20.9044C8.05336 21.0607 8.36746 21.2329 8.86576 21.3865C9.86235 21.6937 11.3181 21.849 13.0532 21.8863C13.1701 21.8887 13.2853 21.9141 13.3923 21.961C13.4994 22.0079 13.5961 22.0753 13.677 22.1595C13.7579 22.2437 13.8213 22.3429 13.8638 22.4515C13.9062 22.5602 13.9268 22.6761 13.9244 22.7927C13.9219 22.9093 13.8965 23.0242 13.8495 23.131C13.8025 23.2378 13.7349 23.3343 13.6505 23.415C13.5662 23.4957 13.4667 23.559 13.3578 23.6014C13.2489 23.6437 13.1327 23.6643 13.0159 23.6618C11.2389 23.6236 9.58117 23.4656 8.34077 23.083C7.72145 22.8912 7.13595 22.624 6.69283 22.229C6.22478 21.8117 5.91602 21.2507 5.91602 20.5635C5.91602 19.8649 6.23457 19.2115 6.66702 18.6646C7.10659 18.1098 7.71434 17.5993 8.42708 17.1643C9.85346 16.297 11.7933 15.6809 13.9244 15.6809C14.3221 15.6809 14.7136 15.7022 15.0954 15.743C15.3301 15.7678 15.5453 15.8847 15.6936 16.0678C15.842 16.251 15.9113 16.4854 15.8864 16.7195C15.8615 16.9537 15.7444 17.1684 15.5608 17.3164C15.3773 17.4644 15.1423 17.5336 14.9076 17.5088C14.5873 17.4741 14.258 17.4564 13.9244 17.4564C12.1243 17.4564 10.5048 17.9802 9.35427 18.6806C8.77856 19.0304 8.34344 19.4103 8.06314 19.7654ZM23.0121 16.5988C22.8055 16.3927 22.5602 16.2291 22.2903 16.1176C22.0204 16.006 21.7311 15.9486 21.4389 15.9486C21.1467 15.9486 20.8574 16.006 20.5874 16.1176C20.3175 16.2291 20.0723 16.3927 19.8657 16.5988L16.8243 19.6323C16.6201 19.8362 16.4877 20.1006 16.447 20.386L16.1534 22.4349C16.1337 22.5716 16.1462 22.7109 16.19 22.8419C16.2337 22.9729 16.3074 23.0919 16.4052 23.1895C16.5031 23.2871 16.6223 23.3606 16.7536 23.4042C16.8849 23.4479 17.0246 23.4604 17.1615 23.4408L19.2152 23.1478C19.5012 23.1072 19.7663 22.9751 19.9707 22.7714L23.0112 19.737C23.4282 19.3208 23.6625 18.7564 23.6625 18.1679C23.6625 17.5794 23.4291 17.015 23.0121 16.5988ZM21.1239 17.8541C21.2078 17.7732 21.3202 17.7285 21.4368 17.7295C21.5535 17.7305 21.6651 17.7772 21.7476 17.8595C21.83 17.9418 21.8768 18.0531 21.8779 18.1695C21.8789 18.2859 21.834 18.398 21.753 18.4817L18.8166 21.4113L18.0825 21.5161L18.1875 20.7837L21.1239 17.8541Z"
                                                  fill="black"
                                                />
                                              </svg>
                                              <div className="flex items-center">
                                                Change Password
                                              </div>
                                            </div>
                                          </Link>
                                        </Menu.Item>
                                        <Menu.Item
                                          className={({ active }) =>
                                            `lg:hidden group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                              active ? "bg-[#F5F5F5]" : ""
                                            }`
                                          }
                                        >
                                          <div
                                            className="flex items-center cursor-pointer"
                                            onClick={() =>
                                              setShowShareProfile(true)
                                            }
                                          >
                                            <svg
                                              width="30"
                                              height="30"
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="rounded-full lg:scale-125"
                                            >
                                              <circle
                                                cx="15"
                                                cy="15"
                                                r="15"
                                                fill="none"
                                              />
                                              <path
                                                d="M19.5986 6C21.4772 6 23 7.5675 23 9.50112C23 11.4347 21.4772 13.0022 19.5986 13.0022C18.5981 13.0022 17.6986 12.5576 17.0763 11.8499L12.6483 14.4539C12.7487 14.7842 12.8027 15.1356 12.8027 15.5C12.8027 15.8644 12.7487 16.2157 12.6483 16.5461L17.0754 19.1511C17.6977 18.4427 18.5976 17.9977 19.5986 17.9977C21.4772 17.9977 23 19.5652 23 21.4989C23 23.4325 21.4772 25 19.5986 25C17.7201 25 16.1972 23.4325 16.1972 21.4989C16.1972 21.1345 16.2513 20.7831 16.3516 20.4528L11.9246 17.8478C11.3022 18.5561 10.4023 19.0011 9.40137 19.0011C7.52285 19.0011 6 17.4336 6 15.5C6 13.5663 7.52285 11.9989 9.40137 11.9989C10.4018 11.9989 11.3014 12.4435 11.9237 13.1512L16.3516 10.5472C16.2513 10.2169 16.1972 9.8655 16.1972 9.50112C16.1972 7.5675 17.7201 6 19.5986 6ZM19.5986 19.4974C18.5248 19.4974 17.6542 20.3936 17.6542 21.4989C17.6542 22.6042 18.5248 23.5003 19.5986 23.5003C20.6724 23.5003 21.543 22.6042 21.543 21.4989C21.543 20.3936 20.6724 19.4974 19.5986 19.4974ZM9.40137 13.4986C8.32752 13.4986 7.45699 14.3947 7.45699 15.5C7.45699 16.6054 8.32752 17.5014 9.40137 17.5014C10.4752 17.5014 11.3457 16.6054 11.3457 15.5C11.3457 14.3947 10.4752 13.4986 9.40137 13.4986ZM19.5986 7.49972C18.5248 7.49972 17.6542 8.39577 17.6542 9.50112C17.6542 10.6064 18.5248 11.5025 19.5986 11.5025C20.6724 11.5025 21.543 10.6064 21.543 9.50112C21.543 8.39577 20.6724 7.49972 19.5986 7.49972Z"
                                                fill="#212121"
                                              />
                                            </svg>

                                            <div>Share Profile</div>
                                          </div>
                                        </Menu.Item>
                                        <Menu.Item
                                          className={({ active }) =>
                                            `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                              active ? "bg-[#F5F5F5]" : ""
                                            }`
                                          }
                                        >
                                          <Link
                                            to="/update_profile"
                                            className="cursor-pointer flex"
                                          >
                                            <svg
                                              width="30"
                                              height="30"
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="rounded-full lg:scale-125"
                                            >
                                              <circle
                                                cx="15"
                                                cy="15"
                                                r="15"
                                                fill="none"
                                              />
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M9.47528 10.3543C9.47528 9.17708 9.94402 8.04805 10.7784 7.21562C11.6128 6.38318 12.7444 5.91553 13.9244 5.91553C15.1043 5.91553 16.236 6.38318 17.0703 7.21562C17.9047 8.04805 18.3735 9.17708 18.3735 10.3543C18.3735 11.5316 17.9047 12.6606 17.0703 13.493C16.236 14.3255 15.1043 14.7931 13.9244 14.7931C12.7444 14.7931 11.6128 14.3255 10.7784 13.493C9.94402 12.6606 9.47528 11.5316 9.47528 10.3543ZM13.9244 7.69104C13.5738 7.69104 13.2267 7.75993 12.9028 7.89377C12.5789 8.02762 12.2847 8.22379 12.0368 8.4711C11.7889 8.71841 11.5923 9.012 11.4581 9.33513C11.324 9.65825 11.2549 10.0046 11.2549 10.3543C11.2549 10.7041 11.324 11.0504 11.4581 11.3735C11.5923 11.6966 11.7889 11.9902 12.0368 12.2375C12.2847 12.4848 12.5789 12.681 12.9028 12.8149C13.2267 12.9487 13.5738 13.0176 13.9244 13.0176C14.6324 13.0176 15.3113 12.737 15.812 12.2375C16.3126 11.7381 16.5938 11.0607 16.5938 10.3543C16.5938 9.64797 16.3126 8.97056 15.812 8.4711C15.3113 7.97164 14.6324 7.69104 13.9244 7.69104ZM8.06314 19.7654C7.77573 20.1294 7.69565 20.4046 7.69565 20.5635C7.69565 20.6683 7.72679 20.7695 7.87806 20.9044C8.05336 21.0607 8.36746 21.2329 8.86576 21.3865C9.86235 21.6937 11.3181 21.849 13.0532 21.8863C13.1701 21.8887 13.2853 21.9141 13.3923 21.961C13.4994 22.0079 13.5961 22.0753 13.677 22.1595C13.7579 22.2437 13.8213 22.3429 13.8638 22.4515C13.9062 22.5602 13.9268 22.6761 13.9244 22.7927C13.9219 22.9093 13.8965 23.0242 13.8495 23.131C13.8025 23.2378 13.7349 23.3343 13.6505 23.415C13.5662 23.4957 13.4667 23.559 13.3578 23.6014C13.2489 23.6437 13.1327 23.6643 13.0159 23.6618C11.2389 23.6236 9.58117 23.4656 8.34077 23.083C7.72145 22.8912 7.13595 22.624 6.69283 22.229C6.22478 21.8117 5.91602 21.2507 5.91602 20.5635C5.91602 19.8649 6.23457 19.2115 6.66702 18.6646C7.10659 18.1098 7.71434 17.5993 8.42708 17.1643C9.85346 16.297 11.7933 15.6809 13.9244 15.6809C14.3221 15.6809 14.7136 15.7022 15.0954 15.743C15.3301 15.7678 15.5453 15.8847 15.6936 16.0678C15.842 16.251 15.9113 16.4854 15.8864 16.7195C15.8615 16.9537 15.7444 17.1684 15.5608 17.3164C15.3773 17.4644 15.1423 17.5336 14.9076 17.5088C14.5873 17.4741 14.258 17.4564 13.9244 17.4564C12.1243 17.4564 10.5048 17.9802 9.35427 18.6806C8.77856 19.0304 8.34344 19.4103 8.06314 19.7654ZM23.0121 16.5988C22.8055 16.3927 22.5602 16.2291 22.2903 16.1176C22.0204 16.006 21.7311 15.9486 21.4389 15.9486C21.1467 15.9486 20.8574 16.006 20.5874 16.1176C20.3175 16.2291 20.0723 16.3927 19.8657 16.5988L16.8243 19.6323C16.6201 19.8362 16.4877 20.1006 16.447 20.386L16.1534 22.4349C16.1337 22.5716 16.1462 22.7109 16.19 22.8419C16.2337 22.9729 16.3074 23.0919 16.4052 23.1895C16.5031 23.2871 16.6223 23.3606 16.7536 23.4042C16.8849 23.4479 17.0246 23.4604 17.1615 23.4408L19.2152 23.1478C19.5012 23.1072 19.7663 22.9751 19.9707 22.7714L23.0112 19.737C23.4282 19.3208 23.6625 18.7564 23.6625 18.1679C23.6625 17.5794 23.4291 17.015 23.0121 16.5988ZM21.1239 17.8541C21.2078 17.7732 21.3202 17.7285 21.4368 17.7295C21.5535 17.7305 21.6651 17.7772 21.7476 17.8595C21.83 17.9418 21.8768 18.0531 21.8779 18.1695C21.8789 18.2859 21.834 18.398 21.753 18.4817L18.8166 21.4113L18.0825 21.5161L18.1875 20.7837L21.1239 17.8541Z"
                                                fill="black"
                                              />
                                            </svg>
                                            <div className="flex items-center">
                                              Update Profile
                                            </div>
                                          </Link>
                                        </Menu.Item>
                                        {dataUser.follower_count >= 100 ? (
                                          <Menu.Item
                                            className={({ active }) =>
                                              `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                                active ? "bg-[#F5F5F5]" : ""
                                              }`
                                            }
                                          >
                                            <div
                                              onClick={() => {
                                                if (
                                                  dataUser.follower_count >= 100
                                                ) {
                                                  userVerificationClicked();
                                                }
                                              }}
                                              className="cursor-pointer flex"
                                            >
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill-opacity={
                                                  dataUser.follower_count < 100
                                                    ? 0.3
                                                    : 1
                                                }
                                                className={`rounded-full lg:scale-125  ${
                                                  dataUser.follower_count < 100
                                                    ? "hidden"
                                                    : ""
                                                }`}
                                              >
                                                <circle
                                                  cx="15"
                                                  cy="15"
                                                  r="15"
                                                  fill="none"
                                                />
                                                <path
                                                  d="M19 15.5C19 14.8974 18.825 14.3287 18.5182 13.8335C17.8409 12.7418 16.5205 12 15 12C12.7909 12 11 13.567 11 15.5C11 16.8304 11.8477 17.9858 13.0955 18.5784C13.6614 18.8469 14.3091 19 15 19C17.2091 19 19 17.433 19 15.5ZM12.4545 15.5C12.4545 14.9054 12.7205 14.3466 13.2 13.925C13.6818 13.5034 14.3205 13.2727 15 13.2727C15.6795 13.2727 16.3182 13.5034 16.8 13.925C17.0368 14.1316 17.2245 14.3771 17.3524 14.6474C17.4804 14.9177 17.546 15.2074 17.5455 15.5C17.5455 16.0946 17.2795 16.6534 16.8 17.075C16.5639 17.2822 16.2833 17.4465 15.9744 17.5584C15.6655 17.6703 15.3344 17.7277 15 17.7273C14.3205 17.7273 13.6818 17.4946 13.2 17.075C12.9632 16.8684 12.7755 16.6229 12.6476 16.3526C12.5196 16.0823 12.454 15.7926 12.4545 15.5Z"
                                                  fill="black"
                                                />
                                                <path
                                                  d="M16.7443 24.8388C16.8801 24.8142 17.0052 24.7489 17.103 24.6516C17.2008 24.5542 17.2666 24.4295 17.2918 24.2938L17.6249 22.4913C18.3928 22.2036 19.1078 21.7909 19.7407 21.2698L21.466 21.8826C21.5959 21.9286 21.7368 21.9339 21.8698 21.8979C22.0029 21.8619 22.1218 21.7863 22.2108 21.6812L22.249 21.6366C22.9875 20.7651 23.5563 19.7811 23.9404 18.7123L23.9595 18.6571C23.9955 18.5596 24.0061 18.4578 23.9955 18.3581C23.9764 18.1906 23.8958 18.0315 23.7621 17.9149L22.3764 16.7294L22.3721 16.7273C22.4379 16.3244 22.4719 15.913 22.4719 15.5016C22.4719 15.1432 22.4464 14.7827 22.3955 14.4307C22.3891 14.384 22.3806 14.3374 22.3742 14.2907C22.3742 14.2865 22.3721 14.2801 22.3721 14.2759L23.7621 13.0883C23.9085 12.9632 23.9934 12.7829 23.9998 12.5963C24.0019 12.5115 23.9892 12.4245 23.9595 12.3418L23.9404 12.2867C23.5577 11.2179 22.9847 10.2272 22.249 9.3623L22.2108 9.31776C22.1216 9.2129 22.0026 9.13752 21.8697 9.10156C21.7367 9.06559 21.596 9.07073 21.466 9.1163L19.7407 9.72917C19.1041 9.20749 18.3953 8.79608 17.6271 8.50767H17.6249L17.2918 6.70512C17.2897 6.69451 17.2875 6.68179 17.2833 6.67119C17.2526 6.54297 17.1854 6.42641 17.0897 6.33568C16.994 6.24495 16.874 6.18395 16.7443 6.16011L16.687 6.14951C15.5813 5.95016 14.4184 5.95016 13.3128 6.14951L13.2555 6.16011C13.1197 6.1847 12.9946 6.25001 12.8968 6.34736C12.799 6.44471 12.7331 6.56949 12.708 6.70512L12.3727 8.51616C11.6106 8.80463 10.901 9.21581 10.2718 9.73341L8.53381 9.1163C8.40386 9.07037 8.26301 9.06505 8.12996 9.10103C7.99691 9.13702 7.87797 9.21261 7.78895 9.31776L7.75075 9.3623C7.01596 10.2278 6.44305 11.2184 6.05942 12.2867L6.04032 12.3418C5.9961 12.4651 5.9884 12.5984 6.01813 12.726C6.04787 12.8535 6.11378 12.9697 6.20797 13.0607C6.21858 13.0692 6.22707 13.0798 6.23768 13.0883L7.64464 14.2886V14.2907C7.57886 14.6894 7.54703 15.0944 7.54703 15.4995C7.54703 15.9066 7.57886 16.3138 7.64464 16.7104L6.23768 17.9107C6.13284 18.0003 6.0578 18.1198 6.02255 18.2531C5.9873 18.3865 5.9935 18.5274 6.04032 18.6571L6.05942 18.7123C6.44353 19.7811 7.01225 20.7672 7.75075 21.6366L7.78895 21.6812C7.89293 21.8021 8.03087 21.8805 8.18154 21.9081C8.29613 21.9293 8.41709 21.9229 8.53381 21.8826L10.2718 21.2655C10.2739 21.2676 10.2782 21.2698 10.2803 21.2719C10.9106 21.7872 11.613 22.1965 12.3727 22.4828L12.708 24.2938C12.7331 24.4295 12.799 24.5542 12.8968 24.6516C12.9946 24.7489 13.1197 24.8142 13.2555 24.8388L13.3128 24.8494C13.8667 24.9491 14.4333 25 14.9999 25H15.0063C15.5707 25 16.1373 24.9491 16.687 24.8494L16.7443 24.8388ZM15.8997 23.4286C15.3003 23.4965 14.6952 23.4965 14.0959 23.4286L13.716 21.3673L12.9139 21.0598C12.309 20.8308 11.7467 20.5042 11.2437 20.0907L10.5774 19.5414L8.59535 20.2455C8.23459 19.7599 7.93325 19.2361 7.69133 18.6847L9.29353 17.3169L9.15559 16.4686C9.10466 16.1526 9.07707 15.8261 9.07707 15.5037C9.07707 15.1793 9.10253 14.8548 9.15559 14.5388L9.29353 13.6906L7.69133 12.3227C7.93113 11.7692 8.23459 11.2476 8.59535 10.7619L10.5774 11.466L11.2437 10.9167C11.7467 10.5032 12.309 10.1766 12.9139 9.9476L13.7181 9.64434L14.098 7.58307C14.6943 7.51521 15.3034 7.51521 15.9018 7.58307L16.2816 9.6401L17.0902 9.94336C17.6992 10.1724 18.2658 10.499 18.773 10.9146L19.4394 11.4617L21.4087 10.764C21.7694 11.2497 22.0708 11.7735 22.3127 12.3249L20.7275 13.6799L20.8654 14.5261C20.9185 14.8463 20.9461 15.175 20.9461 15.5037C20.9461 15.8324 20.9185 16.1611 20.8654 16.4813L20.7254 17.3317L22.3106 18.6868C22.0703 19.2401 21.7669 19.7638 21.4066 20.2476L19.4372 19.5499L18.7709 20.097C18.2637 20.5127 17.6992 20.8393 17.088 21.0683L16.2795 21.3716L15.8997 23.4286Z"
                                                  fill="black"
                                                />
                                              </svg>
                                              <div
                                                className={`flex items-center  ${
                                                  dataUser.follower_count < 100
                                                    ? "hidden"
                                                    : ""
                                                }`}
                                              >
                                                User Verification Request
                                              </div>
                                            </div>
                                          </Menu.Item>
                                        ) : null}
                                        {proStatus && proStatus.result ? (
                                          <Menu.Item
                                            className={({ active }) =>
                                              `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                                active ? "bg-[#F5F5F5]" : ""
                                              }`
                                            }
                                          >
                                            <Link
                                              to="/edit_professional_account"
                                              className="cursor-pointer flex"
                                            >
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="rounded-full lg:scale-125"
                                              >
                                                <circle
                                                  cx="15"
                                                  cy="15"
                                                  r="15"
                                                  fill="none"
                                                />
                                                <path
                                                  d="M19.905 15.6511C22.0988 16.2397 24 17.2029 24 18.5407V23H6V18.5407C6 17.2029 7.90125 16.2397 10.1063 15.6511L10.8038 16.757L11.0625 17.2029C9.375 17.6132 8.1375 18.2018 8.1375 18.5407V21.3055H12.885L13.875 16.7837L12.8175 15.107C13.515 15.0446 14.2463 15 15 15C15.7538 15 16.485 15.0446 17.1825 15.107L16.125 16.7837L17.115 21.3055H21.8625V18.5407C21.8625 18.2018 20.625 17.6132 18.9375 17.2029L19.1962 16.757L19.905 15.6511Z"
                                                  fill="black"
                                                />
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M10 9.26524C10 8.13403 10.4769 7.04915 11.3258 6.24926C12.1747 5.44937 13.3261 5 14.5266 5C15.7271 5 16.8785 5.44937 17.7274 6.24926C18.5763 7.04915 19.0532 8.13403 19.0532 9.26524C19.0532 10.3965 18.5763 11.4813 17.7274 12.2812C16.8785 13.0811 15.7271 13.5305 14.5266 13.5305C13.3261 13.5305 12.1747 13.0811 11.3258 12.2812C10.4769 11.4813 10 10.3965 10 9.26524ZM14.5266 6.7061C14.1699 6.7061 13.8168 6.77229 13.4873 6.9009C13.1577 7.02951 12.8583 7.21802 12.6061 7.45565C12.3539 7.69329 12.1539 7.97541 12.0174 8.2859C11.8809 8.59639 11.8106 8.92917 11.8106 9.26524C11.8106 9.60132 11.8809 9.9341 12.0174 10.2446C12.1539 10.5551 12.3539 10.8372 12.6061 11.0748C12.8583 11.3125 13.1577 11.501 13.4873 11.6296C13.8168 11.7582 14.1699 11.8244 14.5266 11.8244C15.2469 11.8244 15.9378 11.5548 16.4471 11.0748C16.9564 10.5949 17.2426 9.94397 17.2426 9.26524C17.2426 8.58652 16.9564 7.93559 16.4471 7.45565C15.9378 6.97572 15.2469 6.7061 14.5266 6.7061Z"
                                                  fill="black"
                                                />
                                              </svg>

                                              <div className="flex items-center">
                                                Edit Your Professional Account
                                              </div>
                                            </Link>
                                          </Menu.Item>
                                        ) : (
                                          <Menu.Item
                                            className={({ active }) =>
                                              `group flex cursor-pointer items-center gap-2 py-2 px-2 select-none text-black ${
                                                active ? "bg-[#F5F5F5]" : ""
                                              }`
                                            }
                                          >
                                            <Link
                                              to="/professional_account"
                                              className="cursor-pointer flex"
                                            >
                                              <svg
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="rounded-full lg:scale-125"
                                              >
                                                <circle
                                                  cx="15"
                                                  cy="15"
                                                  r="15"
                                                  fill="none"
                                                />
                                                <path
                                                  d="M19.905 15.6511C22.0988 16.2397 24 17.2029 24 18.5407V23H6V18.5407C6 17.2029 7.90125 16.2397 10.1063 15.6511L10.8038 16.757L11.0625 17.2029C9.375 17.6132 8.1375 18.2018 8.1375 18.5407V21.3055H12.885L13.875 16.7837L12.8175 15.107C13.515 15.0446 14.2463 15 15 15C15.7538 15 16.485 15.0446 17.1825 15.107L16.125 16.7837L17.115 21.3055H21.8625V18.5407C21.8625 18.2018 20.625 17.6132 18.9375 17.2029L19.1962 16.757L19.905 15.6511Z"
                                                  fill="black"
                                                />
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M10 9.26524C10 8.13403 10.4769 7.04915 11.3258 6.24926C12.1747 5.44937 13.3261 5 14.5266 5C15.7271 5 16.8785 5.44937 17.7274 6.24926C18.5763 7.04915 19.0532 8.13403 19.0532 9.26524C19.0532 10.3965 18.5763 11.4813 17.7274 12.2812C16.8785 13.0811 15.7271 13.5305 14.5266 13.5305C13.3261 13.5305 12.1747 13.0811 11.3258 12.2812C10.4769 11.4813 10 10.3965 10 9.26524ZM14.5266 6.7061C14.1699 6.7061 13.8168 6.77229 13.4873 6.9009C13.1577 7.02951 12.8583 7.21802 12.6061 7.45565C12.3539 7.69329 12.1539 7.97541 12.0174 8.2859C11.8809 8.59639 11.8106 8.92917 11.8106 9.26524C11.8106 9.60132 11.8809 9.9341 12.0174 10.2446C12.1539 10.5551 12.3539 10.8372 12.6061 11.0748C12.8583 11.3125 13.1577 11.501 13.4873 11.6296C13.8168 11.7582 14.1699 11.8244 14.5266 11.8244C15.2469 11.8244 15.9378 11.5548 16.4471 11.0748C16.9564 10.5949 17.2426 9.94397 17.2426 9.26524C17.2426 8.58652 16.9564 7.93559 16.4471 7.45565C15.9378 6.97572 15.2469 6.7061 14.5266 6.7061Z"
                                                  fill="black"
                                                />
                                              </svg>

                                              <div className="flex items-center">
                                                Upgrade Professional Account
                                              </div>
                                            </Link>
                                          </Menu.Item>
                                        )}
                                      </div>
                                    </Menu.Items>
                                  </Transition>
                                </Menu>
                              </div>
                            </div>
                          ) : (
                            <div className="flex lg:justify-between justify-end">
                              <div className="hidden lg:flex w-56 justify-start">
                                <div className=" flex">
                                  <Tooltip title="Message">
                                    <button
                                      className="whitespace-nowrap inline-flex justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-[#F5F5F5]"
                                      onClick={() =>
                                        messageTargetedUser({
                                          user_id: chooseProfile.user_id,
                                          username: chooseProfile.username,
                                          picture: chooseProfile.picture,
                                        })
                                      }
                                    >
                                      Message
                                    </button>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="flex w-56 justify-end">
                                <div className="hidden lg:flex">
                                  <Tooltip title="Share Profile">
                                    <button
                                      className="whitespace-nowrap inline-flex justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-[#F5F5F5]"
                                      onClick={() => setShowShareProfile(true)}
                                    >
                                      Share Profile
                                    </button>
                                  </Tooltip>
                                  <Modal
                                    open={showShareProfile}
                                    onClose={handleCloseShareProfileModalChat}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                  >
                                    <Box className="modal-notification-style">
                                      <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        component="h2"
                                        style={{
                                          marginBottom: "10%",
                                          marginTop: "5%",
                                          textAlign: "center",
                                        }}
                                      >
                                        Share Profile
                                        <div className="flex justify-center">
                                          <QRCodeSVG
                                            value={`https://siaphub.com/${username}`}
                                            size={200}
                                            bgColor={"#ffffff"}
                                            fgColor={"#000000"}
                                            level={"H"}
                                            includeMargin={false}
                                            imageSettings={{
                                              src:
                                                chooseProfile.picture !== null
                                                  ? chooseProfile.picture
                                                  : "../images/pp/defaultpp.png",
                                              height: 50,
                                              width: 50,
                                              excavate: true,
                                            }}
                                          />
                                        </div>
                                      </Typography>

                                      {/* <div className="m-2 text-center text-sm">{`https://siaphub.com/${username}`}</div> */}
                                      <div className="flex justify-center">
                                        <button
                                          type="button"
                                          className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                                          onClick={() => {
                                            handleCopyLink();
                                            handleCancelButtonModalShareProfile();
                                          }}
                                        >
                                          Copy Link
                                        </button>
                                        <button
                                          type="button"
                                          className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                                          onClick={
                                            handleCancelButtonModalShareProfile
                                          }
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </Box>
                                  </Modal>
                                </div>
                                <Menu
                                  as="div"
                                  className="lg:hidden relative inline-block text-left"
                                >
                                  <Tooltip title="Options">
                                    <Menu.Button className=" inline-flex w-full justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-[#F5F5F5]">
                                      <MoreVertSharpIcon
                                        style={{ cursor: "pointer" }}
                                      />
                                    </Menu.Button>
                                  </Tooltip>
                                  <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                  >
                                    <Menu.Items className="absolute right-0 z-10 w-36 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                      <div className="py-1">
                                        <Menu.Item className="">
                                          <div
                                            className="flex items-center cursor-pointer"
                                            onClick={() =>
                                              setShowShareProfile(true)
                                            }
                                          >
                                            <svg
                                              width="30"
                                              height="30"
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="rounded-full lg:scale-125"
                                            >
                                              <circle
                                                cx="15"
                                                cy="15"
                                                r="15"
                                                fill="white"
                                              />
                                              <path
                                                d="M19.5986 6C21.4772 6 23 7.5675 23 9.50112C23 11.4347 21.4772 13.0022 19.5986 13.0022C18.5981 13.0022 17.6986 12.5576 17.0763 11.8499L12.6483 14.4539C12.7487 14.7842 12.8027 15.1356 12.8027 15.5C12.8027 15.8644 12.7487 16.2157 12.6483 16.5461L17.0754 19.1511C17.6977 18.4427 18.5976 17.9977 19.5986 17.9977C21.4772 17.9977 23 19.5652 23 21.4989C23 23.4325 21.4772 25 19.5986 25C17.7201 25 16.1972 23.4325 16.1972 21.4989C16.1972 21.1345 16.2513 20.7831 16.3516 20.4528L11.9246 17.8478C11.3022 18.5561 10.4023 19.0011 9.40137 19.0011C7.52285 19.0011 6 17.4336 6 15.5C6 13.5663 7.52285 11.9989 9.40137 11.9989C10.4018 11.9989 11.3014 12.4435 11.9237 13.1512L16.3516 10.5472C16.2513 10.2169 16.1972 9.8655 16.1972 9.50112C16.1972 7.5675 17.7201 6 19.5986 6ZM19.5986 19.4974C18.5248 19.4974 17.6542 20.3936 17.6542 21.4989C17.6542 22.6042 18.5248 23.5003 19.5986 23.5003C20.6724 23.5003 21.543 22.6042 21.543 21.4989C21.543 20.3936 20.6724 19.4974 19.5986 19.4974ZM9.40137 13.4986C8.32752 13.4986 7.45699 14.3947 7.45699 15.5C7.45699 16.6054 8.32752 17.5014 9.40137 17.5014C10.4752 17.5014 11.3457 16.6054 11.3457 15.5C11.3457 14.3947 10.4752 13.4986 9.40137 13.4986ZM19.5986 7.49972C18.5248 7.49972 17.6542 8.39577 17.6542 9.50112C17.6542 10.6064 18.5248 11.5025 19.5986 11.5025C20.6724 11.5025 21.543 10.6064 21.543 9.50112C21.543 8.39577 20.6724 7.49972 19.5986 7.49972Z"
                                                fill="#212121"
                                              />
                                            </svg>

                                            <div>Share Profile</div>
                                          </div>
                                        </Menu.Item>
                                      </div>
                                    </Menu.Items>
                                  </Transition>
                                </Menu>
                                <div className="hidden lg:flex ml-3 justify-end">
                                  <button
                                    type="submit"
                                    className={`rounded-lg  ${
                                      isFollowed
                                        ? "text-[#F95C3D] border-2 border-[#F95C3D] bg-white px-4 hover:bg-[#F5F5F5]"
                                        : "bg-[#F95C3D] text-white px-4 hover:bg-orange-600"
                                    }  w-28 rounded-full focus:outline-none font-bold active:scale-95 ease-linear transition-all duration-150`}
                                    onClick={handleButtonFollow}
                                  >
                                    {isLoading ? (
                                      <Box>
                                        <CircularProgress
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        />
                                      </Box>
                                    ) : (
                                      buttonFollow
                                    )}
                                  </button>
                                  <Modal
                                    open={showModalUnfollow}
                                    onClose={handleCloseModalUnfollow}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                  >
                                    <Box className="modal-notification-style">
                                      <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        component="h2"
                                        style={{
                                          marginBottom: "10%",
                                          marginTop: "5%",
                                          textAlign: "center",
                                        }}
                                      >
                                        {chooseProfile.username === null
                                          ? `Are you sure want to unfollow ${chooseProfile.name}?`
                                          : `Are you sure want to unfollow ${chooseProfile.username}?`}
                                      </Typography>
                                      <div className="flex justify-center">
                                        <button
                                          type="button"
                                          className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                                          onClick={handleUnfollowButtonModal}
                                        >
                                          Unfollow
                                        </button>
                                        <button
                                          type="button"
                                          className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                                          onClick={
                                            handleCancelButtonModalUnfollow
                                          }
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </Box>
                                  </Modal>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Profile Picture Section */}
                          <div className="mt-10 flex justify-center">
                            <SetProfilePicture />
                          </div>

                          {/* Name Section */}
                          <div className="flex justify-center">
                            <div className="flex">
                              <Setname />
                              <div className="flex items-center ml-2">
                                {username === dataUser.username ? (
                                  <>
                                    {dataUser.verified ? (
                                      <img
                                        className="w-4 h-4"
                                        alt="verified"
                                        src="../../images/icon_done.png"
                                      ></img>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {chooseProfile.verified ? (
                                      <img
                                        className="w-4 h-4"
                                        alt="verified"
                                        src="../../images/icon_done.png"
                                      ></img>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Username Section */}
                          <div className="flex justify-center mt-[-0.1rem]">
                            <SetUsername />
                          </div>
                        </div>
                      </div>
                      {/* Bio Section */}
                      <div
                        className="bioContainer flex justify-center text-[16px] m-3"
                        style={{
                          height: "16%",
                          wordBreak: "break-word",
                          color: "#B6B0B0",
                        }}
                      >
                        {chooseProfile.bio
                          ? chooseProfile.bio.split("\n").map((line, index) => (
                              <span key={index}>
                                {line}
                                <br />
                              </span>
                            ))
                          : "No Bio"}
                      </div>

                      {/* only for desktop follow section*/}
                      <div className="bg-[#F5F5F5] drop-shadow-lg rounded-lg px-1 py-2">
                        <div
                          className="flex"
                          style={{ justifyContent: "space-evenly" }}
                        >
                          <div className="container">
                            <p className="flex justify-center text-base lg:text-xl">
                              {chooseProfile.total_posts === null
                                ? "0"
                                : chooseProfile.total_posts}
                            </p>
                          </div>
                          <div className="border-l-[1px] border-r-[1px] border-gray-400 h-8"></div>
                          <div className="container">
                            <span
                              onClick={() => handleOpen("followers")}
                              className="flex justify-center text-base lg:text-xl cursor-pointer"
                            >
                              {chooseProfile.follower_count === null
                                ? "0"
                                : chooseProfile.follower_count}
                            </span>
                          </div>
                          <div className="border-l-[1px] border-r-[1px] border-gray-400 h-8"></div>
                          <div className="container">
                            <span
                              onClick={() => handleOpen("following")}
                              className="flex justify-center text-base lg:text-xl cursor-pointer"
                            >
                              {chooseProfile.following_count === null
                                ? "0"
                                : chooseProfile.following_count}
                            </span>
                          </div>
                          <div className="border-l-[1px] border-r-[1px] border-gray-400 h-8"></div>
                          <div className="container">
                            <p className="flex justify-center text-base lg:text-xl">
                              {chooseProfile.total_likes === null
                                ? "0"
                                : chooseProfile.total_likes}
                            </p>
                          </div>
                        </div>
                        <div
                          className="flex"
                          style={{ justifyContent: "space-evenly" }}
                        >
                          <div className="container">
                            <p className="flex justify-center text-[#B6B0B0] text-base lg:text-xl">
                              Posts
                            </p>
                          </div>
                          <div className="border-l-[1px] border-r-[1px] border-gray-400 h-6"></div>
                          <div className="container">
                            <span
                              onClick={() => handleOpen("followers")}
                              className="flex justify-center text-[#B6B0B0] text-base lg:text-xl cursor-pointer"
                            >
                              Followers
                            </span>
                          </div>
                          <div className="border-l-[1px] border-r-[1px] border-gray-400 h-6"></div>
                          <div className="container">
                            <span
                              onClick={() => handleOpen("following")}
                              className="flex justify-center text-[#B6B0B0] text-base lg:text-xl cursor-pointer"
                            >
                              Following
                            </span>
                          </div>
                          <div className="border-l-[1px] border-r-[1px] border-gray-400 h-6"></div>
                          <div className="container">
                            <p className="flex justify-center text-[#B6B0B0] text-base lg:text-xl">
                              Likes
                            </p>
                          </div>
                        </div>
                      </div>

                      <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        className="flex items-center justify-center"
                      >
                        <Box className="modal-notification-style">
                          <FollowersFollowing
                            chooseProfile={chooseProfile}
                            tab={tab}
                            handleClose={handleClose}
                          />
                        </Box>
                      </Modal>

                      {/* Contact Section */}
                      {chooseProfile.contact === undefined ||
                      chooseProfile.length === 0 ||
                      chooseProfile.contact === null ? (
                        ""
                      ) : (
                        <>
                          <div className="flex justify-center my-3">
                            {Object.keys(chooseProfile.contact).map(
                              (contactId) => {
                                const contact = dataAllContactList.find(
                                  (item) =>
                                    item.id ===
                                    chooseProfile.contact[contactId]
                                      .listcontact_id
                                );
                                return contact ? (
                                  <button
                                    key={contact.id}
                                    onClick={() => openContact(contact.id)}
                                  >
                                    <img
                                      src={
                                        Array.isArray(socialMediaOptions) &&
                                        socialMediaOptions.find(
                                          (option) =>
                                            option.label === contact.name
                                        )?.image
                                      }
                                      alt={contact.name}
                                      className="lineButton ml-1"
                                    />
                                  </button>
                                ) : null;
                              }
                            )}
                          </div>
                        </>
                      )}

                      {/* message section mobile */}
                      <div
                        className={`bioContainer flex justify-center  m-3 lg:hidden ${
                          username === dataUser.username ? "hidden" : ""
                        }`}
                      >
                        <div className="flex justify-center m-1">
                          <div className=" flex">
                            <Tooltip title="Message">
                              <button
                                className="whitespace-nowrap inline-flex justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-[#F5F5F5]"
                                onClick={() =>
                                  messageTargetedUser({
                                    user_id: chooseProfile.user_id,
                                    username: chooseProfile.username,
                                    picture: chooseProfile.picture,
                                  })
                                }
                              >
                                Message
                              </button>
                            </Tooltip>
                          </div>
                        </div>
                        <div className="flex justify-center m-1">
                          <div className="flex justify-center">
                            <button
                              type="submit"
                              className={`rounded-lg  ${
                                isFollowed
                                  ? "text-[#F95C3D] border-2 border-[#F95C3D] bg-white px-4 hover:bg-[#F5F5F5]"
                                  : "bg-[#F95C3D] text-white px-4 hover:bg-orange-600"
                              }  w-28 rounded-full focus:outline-none font-bold active:scale-95 ease-linear transition-all duration-150`}
                              onClick={handleButtonFollow}
                            >
                              {isLoading ? (
                                <Box>
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                    }}
                                  />
                                </Box>
                              ) : (
                                buttonFollow
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Profile Bottom Desktop Layout */}
                <div className="hidden lg:flex">
                  <div>
                    {/* Tab Navigation */}
                    <div className="flex justify-center mb-6 border-b">
                      <button
                        className={`px-4 py-2 font-semibold text-lg border-b-2 transition-all duration-300 ${
                          activeTab === "posts"
                            ? "border-blue-500 text-blue-500"
                            : "border-transparent text-gray-500 hover:text-blue-500"
                        }`}
                        onClick={() => setActiveTab("posts")}
                      >
                        Posts
                      </button>
                      <button
                        className={`px-4 py-2 font-semibold text-lg border-b-2 transition-all duration-300 ${
                          activeTab === "catalog"
                            ? "border-blue-500 text-blue-500"
                            : "border-transparent text-gray-500 hover:text-blue-500"
                        }`}
                        onClick={() => setActiveTab("catalog")}
                      >
                        Catalog
                      </button>
                    </div>

                    {/* Conditionally Render Sections */}
                    {activeTab === "posts" ? (
                      <div className="bg-white shadow-md p-6 rounded-lg">
                        {/* Posts Section */}
                        <h2 className="text-2xl font-semibold mb-4">
                          User Posts
                        </h2>
                        {userPosts.length === 0 ? (
                          <div className="text-gray-500 flex items-center justify-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              className="w-12 h-12"
                            >
                              <path
                                fill="#d1d1d1"
                                fillRule="evenodd"
                                d="M3.25 4a.25.25 0 00-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 01.75.75v3.19l3.427-3.427A1.75 1.75 0 0111.164 17h9.586a.25.25 0 00.25-.25V4.25a.25.25 0 00-.25-.25H3.25zm-1.75.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 01-1.75 1.75h-9.586a.25.25 0 00-.177.073l-3.5 3.5A1.457 1.457 0 015 21.043V18.5H3.25a1.75 1.75 0 01-1.75-1.75V4.25zM12 6a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0v-4A.75.75 0 0112 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
                              ></path>
                            </svg>
                            <p className="ml-6">No posts yet</p>
                          </div>
                        ) : (
                          <ImageList
                            sx={{ width: "100%", height: "auto" }}
                            cols={3}
                          >
                            {userPosts.map((post) => (
                              <ImageListItem
                                key={post.slug}
                                className="cursor-pointer relative overflow-hidden bg-white"
                                style={{
                                  alignItems: "center",
                                  border: "0.1px solid gainsboro",
                                  borderRadius: "0.5em",
                                }}
                                onClick={() => handleOpenPostModal(post)}
                              >
                                <div className="absolute right-0 top-0 h-16 w-16">
                                  <div
                                    className={`absolute transform rotate-45 text-center font-semibold right-[-50px] top-[20px] w-[170px] h-6 ${getTypeColor(
                                      post.post_type,
                                      post.sd_post_type
                                    )} text-white`}
                                  >
                                    {getTypeName(
                                      post.post_type,
                                      post.sd_post_type
                                    )}
                                  </div>
                                </div>
                                <SetDefaultImage postObject={post} />
                              </ImageListItem>
                            ))}
                          </ImageList>
                        )}

                        {/* Modal for viewing post details */}
                        <Modal
                          open={showPostModal}
                          onClose={handleClosePostModal}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                          className="flex items-center justify-center"
                        >
                          <div className="bg-white rounded-lg p-4 w-9/12 max-h-[90%] outline-none">
                            <PostProfile
                              key={postModalKey}
                              onePost={postModalData}
                            />
                          </div>
                        </Modal>
                      </div>
                    ) : (
                      <div className="max-w-6xl mx-auto p-4">
                        <header className="text-center mb-8">
                          <h1 className="text-3xl font-bold">Ginchoux</h1>
                          <p>Fresh Cakes & Liquor Dessert</p>
                          <div className="flex items-center justify-center mt-2">
                            {/* Address Icon */}
                            <MdLocationOn className="h-5 w-5 text-gray-600 mr-2" />
                            <p>
                              Jl. Penyelesaian Tomang Kav BRI Blok B/5, Jakarta
                            </p>
                          </div>
                          <div className="flex items-center justify-center mt-2">
                            {/* Business Hours Icon */}
                            <MdAccessTime className="h-5 w-5 text-gray-600 mr-2" />
                            <p>Everyday: 8 AM - 10 PM</p>
                          </div>
                        </header>

                        {categories.map((category) => (
                          <CategoryCard
                            key={category.name}
                            category={category}
                          />
                        ))}

                        <footer className="text-center mt-12">
                          <p>Connect with us:</p>
                          <div className="flex justify-center space-x-4 mt-2">
                            <a
                              href="https://www.facebook.com"
                              className="text-blue-600 hover:underline"
                            >
                              Facebook
                            </a>
                            <a
                              href="https://www.instagram.com"
                              className="text-pink-600 hover:underline"
                            >
                              Instagram
                            </a>
                            <a
                              href="https://wa.me"
                              className="text-green-600 hover:underline"
                            >
                              WhatsApp
                            </a>
                          </div>
                        </footer>
                      </div>
                    )}
                  </div>
                </div>

                {/* Card Profile Bottom Mobile Layout */}
                <div
                  className="lg:hidden"
                  style={userPosts.length === 0 ? {} : { width: "100%", height: "auto" }}
                >
                  <div
                    className="bg-white shadow-md p-6 rounded-lg"
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      margin: "0",
                      display: "flex",
                      paddingLeft: "0.5rem",
                    }}
                  >
                    <div
                      className="w-full h-full"
                      style={{ marginLeft: "0.5rem" }}
                    >
                      <div
                        className="flex flex-col px-1"
                        style={{ justifyContent: "space-evenly" }}
                      >
                        {/* <div className="mb-1 lg:hidden">
                          <p className="font-bold text-[18px]">
                            {userPosts.length === 1 ? "Group" : "Groups"} (
                            {userPosts.length}) :
                          </p>
                          <ImageList
                            // sx={{ width: "100%", height: "auto" }}
                            // sx={{ width: "50%", height: "50%" }}
                            // sx={{ width: 250, height: 250 }}
                            cols={2}
                            ref={divRef}
                            onScroll={handleScroll}
                          >
                            {userPosts.map((userPost) => (
                              <ImageListItem
                                key={userPost.slug}
                                style={{
                                  alignItems: "center",
                                  border: "1px solid ",
                                  borderColor: "rgb(182, 176, 176)",
                                  borderRadius: "0.5em",
                                }}
                                onClick={() => handleOpenPostModal(userPost)}
                              >
                                <SetDefaultImageMobile userPost={userPost} />
                              </ImageListItem>
                            ))}
                          </ImageList>
                        </div> */}
                        <h2 className="text-2xl font-semibold mb-4">
                          User Posts
                        </h2>
                        {userPosts.length === 0 ? (
                          <div className="text-gray-500 flex items-center justify-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              className="w-12 h-12"
                            >
                              <path
                                fill="#d1d1d1"
                                fillRule="evenodd"
                                d="M3.25 4a.25.25 0 00-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 01.75.75v3.19l3.427-3.427A1.75 1.75 0 0111.164 17h9.586a.25.25 0 00.25-.25V4.25a.25.25 0 00-.25-.25H3.25zm-1.75.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 01-1.75 1.75h-9.586a.25.25 0 00-.177.073l-3.5 3.5A1.457 1.457 0 015 21.043V18.5H3.25a1.75 1.75 0 01-1.75-1.75V4.25zM12 6a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0v-4A.75.75 0 0112 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
                              ></path>
                            </svg>
                            <p className="ml-6">No posts yet</p>
                          </div>
                        ) : (
                          <>
                            <div className="m-1 ml-3">
                              {/* <p className="font-bold text-[18px] mb-4 lg:hidden">
                                {userPosts.length === 1 ? "User Post" : "Posts"}{" "}
                                ({userPosts.length}) :
                              </p> */}
                              <ImageList
                                sx={{
                                  width: "100%",
                                  height: "auto",
                                  display: "grid",
                                  gap: "8px",
                                  gridTemplateColumns:
                                    "repeat(auto-fill, minmax(85px, 1fr))", // Default 1 kolom
                                  [theme.breakpoints.up("lmm")]: {
                                    gridTemplateColumns:
                                      "repeat(auto-fill, min(85px, 1fr))", //  kolom untuk layar sm
                                  },
                                  [theme.breakpoints.up("lm")]: {
                                    gridTemplateColumns:
                                      "repeat(auto-fill, minmax(150px, 1fr))", //  kolom untuk layar sm
                                  },
                                  [theme.breakpoints.up("sm")]: {
                                    gridTemplateColumns:
                                      "repeat(auto-fill, minmax(120px, 1fr))", // 2 kolom untuk layar sm
                                  },
                                  [theme.breakpoints.up("md")]: {
                                    gridTemplateColumns:
                                      "repeat(auto-fill, minmax(180px, 1fr))", // 3 kolom untuk layar md
                                  },
                                  [theme.breakpoints.up("xl")]: {
                                    gridTemplateColumns:
                                      "repeat(auto-fill, minmax(200px, 1fr))", // 4 kolom untuk layar xl
                                  },
                                }}
                                cols={
                                  isXl
                                    ? 5
                                    : isMd
                                    ? 4
                                    : isSm
                                    ? 3
                                    : isLm
                                    ? 2
                                    : isLmm
                                    ? 2
                                    : 1
                                }
                                ref={divRef}
                                onScroll={handleScroll}
                              >
                                {userPosts.map((userPost) => (
                                  <ImageListItem
                                    className="cursor-pointer  relative overflow-hidden "
                                    key={userPost.slug}
                                    style={{
                                      alignItems: "center",
                                      border: "0.1px solid gainsboro",
                                      borderRadius: "0.5em",
                                    }}
                                    onClick={() =>
                                      handleOpenPostModal(userPost)
                                    }
                                  >
                                    <div className="absolute right-0 top-0 h-16 w-16">
                                      <div
                                        className={`absolute transform rotate-45 text-center font-semibold py-1 right-[-35px] top-[20px] w-[130px] ${getTypeColor(
                                          userPost.post_type,
                                          userPost.sd_post_type
                                        )} text-white`}
                                      >
                                        {getTypeName(
                                          userPost.post_type,
                                          userPost.sd_post_type
                                        )}
                                      </div>
                                    </div>
                                    <SetDefaultImage postObject={userPost} />
                                  </ImageListItem>
                                ))}
                              </ImageList>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default ProfileScreen;
